import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem("sumbulaga-cart");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("sumbulaga-cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product, weight, quantity = 1) => {
    setCartItems((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item.product_id === product.id && item.weight === weight
      );

      if (existingIndex > -1) {
        const updated = [...prev];
        updated[existingIndex].quantity += quantity;
        return updated;
      }

      return [
        ...prev,
        {
          product_id: product.id,
          product_name: product.name,
          quantity,
          weight,
          price: product.price,
          image_url: product.image_url,
          slug: product.slug,
        },
      ];
    });
  };

  const removeFromCart = (productId, weight) => {
    setCartItems((prev) =>
      prev.filter(
        (item) => !(item.product_id === productId && item.weight === weight)
      )
    );
  };

  const updateQuantity = (productId, weight, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId, weight);
      return;
    }

    setCartItems((prev) =>
      prev.map((item) =>
        item.product_id === productId && item.weight === weight
          ? { ...item, quantity }
          : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const getCartTotal = () => {
    return cartItems.reduce((total, item) => {
      const priceMultiplier = item.weight === 250 ? 2.2 : item.weight === 500 ? 4 : 1;
      return total + item.price * priceMultiplier * item.quantity;
    }, 0);
  };

  const getCartCount = () => {
    return cartItems.reduce((count, item) => count + item.quantity, 0);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        getCartTotal,
        getCartCount,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
}
